import React from 'react';
import {useTranslation} from 'react-i18next';
import {
	LinkAgentRegDoc,
	LinkAgentRequirement,
	LinkAgentPOGIS,
} from './CoPiltPageConstants';
import {CommandButton, Stack} from '@fluentui/react';
import {buildNavItems} from 'appShell/Layout/SideNavigation';

export const CoPilotPage = () => {
	const {t} = useTranslation('features/copilotintegration');

	const {t: tNav} = useTranslation('appShell/sidenavigation', {
		keyPrefix: 'SideNavigation',
	});

	const agentsInfo = {
		regulations: LinkAgentRegDoc,
		pogisArchive: LinkAgentPOGIS,
		requirements: LinkAgentRequirement,
	};

	const agents = buildNavItems(tNav)
		.map(x => {
			const agentInfo = agentsInfo[x.key as keyof typeof agentsInfo];
			if (agentInfo) {
				return {...x, url: agentInfo};
			} else {
				return null;
			}
		})
		.filter(x => x);

	const createCommandButton = (props: any) => {
		return (
			<CommandButton
				iconProps={{iconName: props.icon}}
				text={props.name}
				onClick={() => {
					window.open(props.url, '_blank');
				}}
			/>
		);
	};

	return (
		<div style={{paddingLeft: 20, maxWidth: 900}}>
			<h2>{t('copilotPage.title')}</h2>
			<h3>{t('copilotPage.agents')}</h3>
			<Stack>
				{agents.map(agentProps => (
					<Stack.Item>{createCommandButton(agentProps)}</Stack.Item>
				))}
			</Stack>
			<p>
				<strong>{t('copilotPage.important')}</strong>
			</p>

			<p>
				{t('copilotPage.settings')}
				<br />
				<br />
				{t('copilotPage.pinHint')}
			</p>

			<h3>{t('copilotPage.accessRights.title')}</h3>
			<p>{t('copilotPage.accessRights.text')}</p>
			<ul>
				<li>{t('copilotPage.accessRights.group')}</li>
			</ul>
		</div>
	);
};
